module.exports = __webpack_public_path__ + "img/bg.5d18de1d.webp";